import React from "react";
import Box from "../box/Box";
import { COLORS, Typo } from "../../../../../layout/theme";
import { BiBox, BiDollar, BiCoinStack, BiTrash, BiCheck } from "react-icons/bi";
import {
	AntdTable,
	BigChartContainer,
	Container,
	Dashboard1Container,
	DoubleChartContainer,
	FilterContainer,
	HeaderContainer,
} from "./styles";
import { Button, DatePicker, Select } from "antd";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import { CONSTANTS } from "../../../../../../utils/constants";
import Image from "../../../../../common/image/Image";
import NoImageUser from "../../../../../../assets/images/SinImagenDeUsuario.jpeg";
import DebounceSelectSeller from "../../../../../common/debounce-select-seller/DebounceSelectSeller";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";

export default function MobileDashboard({
	dashboard,
	distributors,
	selectDistributor,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedDistributor,
	posOrderingGraph,
	sellersTable,
	sellers,
	selectSeller,
	selectedSeller,
	selectPeriod,
	rangeDate,
	mobilePeriod,
	userdata,
	selectedCategory,
	selectCategory,
	categories,
	handleApplyFilters,
}) {
	const columns = [
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}></div>,
			dataIndex: "sellerPhotoUrl",
			align: "center",
			width: 120,
			render: (value, record, index) => (
				<Image
					width={50}
					height={50}
					src={value ? value : NoImageUser}
					alt={record.sellerFirstName ? record.sellerFirstName : "No image"}
					borderRadius={40}
				/>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Nombre</div>,
			width: 260,
			dataIndex: "sellerFirstName",
			render: (value, record) => (
				<div
					style={{ cursor: "pointer" }}
					onClick={() => {
						selectSeller(record.sellerId, {
							label: value + " " + record.sellerLastName,
						});
					}}
				>
					<Typo level={5}>
						{value} {record.sellerLastName}
					</Typo>
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Unidades</div>,
			dataIndex: "totalUnits",
			render: (value, record) => (
				<Typo type="primary" level={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>%</div>,
			dataIndex: "totalUnits",
			width: 80,
			render: (value, record) => (
				<Typo type="success" level={6}>
					{((value * 100) / dashboard?.totalUnits)?.toFixed(0)} %
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Ventas</div>,
			dataIndex: "totalSales",
			render: (value, record) => (
				<Typo type="primary" level={14}>
					$ {numberWithDotAndCommas(value?.toFixed(0))}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>%</div>,
			dataIndex: "totalSales",
			width: 80,
			render: (value, record) => (
				<Typo type="success" level={6}>
					{((value * 100) / dashboard?.totalSales)?.toFixed(0)} %
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Ordenes</div>,
			dataIndex: "totalOrders",
			render: (value, record) => (
				<Typo type="primary" level={14}>
					{value}
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>%</div>,
			dataIndex: "totalOrders",
			width: 80,
			render: (value, record) => (
				<Typo type="success" level={6}>
					{((value * 100) / dashboard?.totalOrders)?.toFixed(0)} %
				</Typo>
			),
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>$ Promedio</div>,
			dataIndex: "totalSales",
			render: (value, record) => (
				<Typo type="secondary" level={14}>
					$ {numberWithDotAndCommas((value / record.totalOrders)?.toFixed(0))}
				</Typo>
			),
		},
	];

	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "140px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha
					</Typo>
					<DatePicker.RangePicker
						format="DD/MM/YYYY"
						value={rangeDate}
						onChange={(e) => handleDateChange(e)}
						placeholder={["Desde", "Hasta"]}
						disabled={mobilePeriod === CONSTANTS.PERIOD_CURRENT}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Período
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Período"
						optionFilterProp="children"
						value={mobilePeriod}
						onChange={(e) => selectPeriod(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={CONSTANTS.MOBILE_DASHBOARD_PERIODS}
						style={{ width: 130 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						// allowClear
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						// defaultValue={selectedDistributor ?? null}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 180 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Categoria
					</Typo>
					<Select
						showSearch
						// allowClear
						placeholder="Categoria"
						optionFilterProp="children"
						value={selectedCategory}
						// defaultValue={selectedProvince ?? null}
						onChange={(e, o) => selectCategory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={categories}
						style={{ width: 220 }}
					/>
				</Container>
				{!(!userdata.p_shop && userdata.p_mobile) && (
					<Container>
						<Typo type="primary" level={6}>
							Vendedor
						</Typo>
						<DebounceSelectSeller
							fetchCallback={sellers}
							placeholder="Vendedor"
							onValuesChange={selectSeller}
							initialValues={selectedSeller}
						/>
					</Container>
				)}
			</FilterContainer>
			<HeaderContainer>
				<Box
					data={numberWithDotAndCommas(dashboard?.totalSales?.toFixed(0))}
					dataPrefix={"$"}
					secondData={dashboard?.totalUnits}
					secondDataSuffix={"un."}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					isLoading={isLoading}
					type="headerBoxMobile"
					title={
						<Typo texto="light" type="primary">
							Ventas período
						</Typo>
					}
				/>
				<Box
					data={dashboard?.totalOrders}
					dataSuffix={"Transfers"}
					secondData={dashboard?.totalOrderPos}
					secondDataSuffix={"Puntos de venta"}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					isLoading={isLoading}
					type="headerBoxMobile"
					title={
						<>
							<Typo texto="light" type="primary">
								Puntos de venta asignados:{" "}
							</Typo>
							<Typo type="primary" level={3}>
								{selectedSeller
									? dashboard?.totalUserRoutes
									: dashboard?.totalLaboratoryRoutes}
							</Typo>
						</>
					}
				/>
				<Box
					title={
						<Typo texto="light" type="primary">
							Histórico ruta
						</Typo>
					}
					graphData={posOrderingGraph}
					monthName={CONSTANTS.CALENDAR_MONTHS[dashboard?.actualMonth]}
					isLoading={isLoading}
					type="headerBoxMobile"
				/>
			</HeaderContainer>
			<BigChartContainer>
				<AntdTable
					dataSource={sellersTable}
					loading={isLoading}
					columns={columns}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
			</BigChartContainer>
		</Dashboard1Container>
	);
}
